import axios from "axios"
import { useStoreState } from "easy-peasy"
import { useEffect, useState } from "react"
import { USER_UPD_MODULES_URL } from "./Constants.js"

// PURPOSE: Render an individual user module as a table row
//          Called by UserModuleFeed.js
const UserModuleList = ({ module, isInitialUser }) => {
	const [isBoxChecked, setIsBoxChecked] = useState("")

	// Easy-Peasy
	const Grants = useStoreState((state) => state.Grants)
	const Token = useStoreState((state) => state.Token)
	const selectedUser = useStoreState((state) => state.selectedUser)

	let mod_id = module[0]
	let mod_name = module[1]

	useEffect(() => {
for (let i = 0; i < Grants.length; i++) {
			// Each grant contains {id, module_id, role} from the user_module table
			if (Number(Grants[i][1]) === Number(mod_id)) {
				setIsBoxChecked("checked")
			}
		}
	}, [])

	function handleChange() {
		if (isBoxChecked) {
			setIsBoxChecked("")
			PostUpd("delete")
		} else {
			setIsBoxChecked("checked")
			PostUpd("add")
		}
	}

	async function PostUpd(action) {
		try {
			const request = {
				login_id: Token.login_id,
				client_id: Token.client_id,
				action: action,
				mod_id: mod_id,
				selected_user_id: selectedUser,
			}
await axios.put(USER_UPD_MODULES_URL, request)
		} catch (err) {
			console.error("UserModuleList PostUpd:", err)
		}
	}

	return (
		<tr className="userRow">
			<td hidden id={mod_id}>
				{mod_id}
			</td>
			<td id={mod_name}>{mod_name}</td>
			<td className="ckboxtd">
				<input
					className={mod_name}
					type="checkbox"
					checked={isInitialUser ? true : !!isBoxChecked}
					disabled={isInitialUser}
					onChange={isInitialUser ? undefined : handleChange}
				/>
			</td>
		</tr>
	)
}

export default UserModuleList
